import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=5dd16c0d&"
import script from "./type1.vue?vue&type=script&lang=js&"
export * from "./type1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports